module.exports = __webpack_public_path__ + "static/img/xiangqing.ee75b29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/xiangqing.png
// module id = /XdQ
// module chunks = 24